var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 199.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b143ff;}.cls-2{fill:#ffec00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2-2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "500 0 36.45 0 0 44.43 0 199.45 463.55 199.45 500 155.01 500 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.58 14.29 34.28 30.14 456.6 30.14 469.81 14.29 47.58 14.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.37 55.3 214.39 55.3 211.25 68.65 232.23 68.65 235.37 55.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.46 85.55 228.44 85.55 231.57 72.19 210.6 72.19 207.46 85.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.79,86.65l7.37-31.35h-52L92.45,109.36h18.9l4.19-17.83L130,109.41h21.57l0,0H195.1l3.44-14.59H171.91l1.21-5.15h26.63L203.18,75H176.55l1.22-5.14h26.62l3.43-14.59H162.3L150,107.48,139.74,94.77h1.37ZM131.4,84.47l-3.47-4.28h-9.72l2.43-10.3h14.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.32,119.74H46.9L34.18,173.81H80.36L89,165.68l10.81-45.94ZM71.66,159.22H56.51l5.86-24.89H77.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.95 119.74 310.59 142.53 305.31 136 307.99 124.57 296.05 124.57 292.12 119.72 270.55 119.72 270.57 119.74 270.54 119.74 257.82 173.81 276.72 173.81 285.19 137.8 294.21 148.94 309.08 148.94 303.23 173.81 322.13 173.81 334.85 119.74 315.95 119.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.92,119.74H213.34l-12.72,54.07h18.9l4.64-19.74h12.72l-4.64,19.74h18.9l10.22-43.47Zm-15.61,19.74H227.59l1.21-5.15h12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.75,154.07l3.43-14.59H176.55l1.22-5.15h26.62l3.43-14.59H162.3L150,171.92l-10.28-12.7h1.37l8.68-8.13,7.37-31.35h-52L92.45,173.81h18.9L115.54,156,130,173.86h21.57l0-.05H195.1l3.44-14.59H171.91l1.21-5.15Zm-68.35-5.15-3.47-4.29h-9.72l2.43-10.3h14.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "347.3 159.22 348.51 154.07 375.14 154.07 378.57 139.48 351.94 139.48 353.16 134.33 379.78 134.33 383.22 119.74 356.59 119.74 347.88 119.74 337.69 119.74 324.97 173.81 340.78 173.81 343.87 173.81 370.5 173.81 373.93 159.22 347.3 159.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431.26,151.09l7.38-31.35h-52l-12.72,54.07h18.9L397,156l14.48,17.89h21.57l-11.85-14.64h1.37Zm-18.38-2.17-3.47-4.29h-9.72l2.42-10.3h14.2Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f58bcc271dbc61cc1ccf0d37b0ad946.svg";
export { ForwardRef as ReactComponent };